<template>
  <div>
        <!-- Every lock below binds :readonly, not :disabled. A disabled dropdown greys its own
             selected text out, and on the screens that reuse this component a locked district or
             tax year is still something staff read off the record. In Vuetify 2 (2.4.11 here)
             `isInteractive` is (!disabled && !readonly),
             and VSelect gates menu activation, click, keydown and lookup on it - so readonly
             shuts the list just as firmly as disabled did, while leaving the value legible and
             stamping .v-input--is-readonly for the grey fill in style.css.
             The public prop names stay `is*Disabled` so no caller has to change; they mean
             "lock this control", and how that lock renders is this component's business.
             The paired :tabindex is written out inline rather than pulled from a shared helper:
             specs mount these components directly, so anything registered only in main.js is
             absent under test. -->
        <v-select v-if="isItTaxYear" :items="taxYearList"
         class="input-text-size" label="Tax Year"
         item-text="name"
         item-value="value"
         :value="computedTaxYearValue"
         :readonly="isTaxYearDisabled"
         :tabindex="isTaxYearDisabled ? -1 : 0"
         @change="val => changed(val, 'taxYear')" />
        <v-select v-if="isItTaxYearWithoutAllYears" :items="removeAllYearsFromTaxYearList()"
         class="input-text-size" :label=taxYearLabelOverride
         item-text="name"
         item-value="value"
         :readonly="isTaxYearWithoutAllDisabled"
         :tabindex="isTaxYearWithoutAllDisabled ? -1 : 0"
         :value="handleDynamicTaxValChange()"
         @change="val => changed(val, taxYearNameOverride)" />
         <v-select v-if="isItTaxYearWithNewYear" :items="removeAllYearsFromTaxYearListWithNewYear()"
         class="input-text-size" :label=taxYearLabelWithNewYearOverride
         item-text="name"
         item-value="value"
         :readonly="isTaxYearWithNewYearDisabled"
         :tabindex="isTaxYearWithNewYearDisabled ? -1 : 0"
         :value="handleDynamicTaxValChange()"
         @change="val => changed(val, taxYearNameWithNewYearOverride)" />
         <v-select v-if="isItFiscalYear" :items="handleFiscalYearWithoutAllYears()"
         class="input-text-size" label="Fiscal Year"
         item-text="name"
         item-value="value"
         :value="handleDynamicFiscalValChange()"
         :readonly="isFiscalYearDisabled"
         :tabindex="isFiscalYearDisabled ? -1 : 0"
         @change="val => changed(val, 'fiscalYear')" />
         <v-autocomplete v-if="isItMtgCode" :items="combineMtgCodes"
          class="input-text-size" label="Mtg Code"
          v-model="vModelList.mtgCode"
          item-text="name"
          item-value="value"
          :loading="isLoading"
          :readonly="isMtgCodeDisabled"
          :tabindex="isMtgCodeDisabled ? -1 : 0"
          :search-input.sync="searchMtgCodes"
          @change="val => changed(val, 'mtgCode')"
          >
          <!-- :value="mtgCodeValue" -->
            <template v-slot:append-item>
              <!-- The v-intersect directive detects when this element is visible -->
              <v-list-item v-intersect="onAutocompleteIntersect">
                <v-list-item-content v-if="isLoading">
                  <v-list-item-title class="text-center">Loading more...</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-autocomplete>
        <v-row v-if="isItMtgCodeMutiSelect">
        <v-col cols="8">
        <span class="input-text-size pa-0" outlined
        >Selected Codes :
        <span v-for="data in vModelList.mtgCodeMulti" v-bind:key="data">
          <v-chip close @click:close="remove(data)">
              {{ data }}
            </v-chip>
          </span>
        </span>
      </v-col>
          <v-col cols="4">
        <v-autocomplete :items="removeEmptyFromMtgCodesList()"
          class="input-text-size" label="Mtg Code"
          v-model="vModelList.mtgCodeMulti"
          item-text="name"
          item-value="value"
          :loading="isLoading"
          :search-input.sync="searchMtgCodesMulti"
          multiple
          @change="onMultiMtgCodechange"
          >
          <template v-slot:selection="" />
          <template v-slot:item="data">
            <template v-if="typeof data.item !== 'object'">
              <v-list-item-content v-text="data.item"></v-list-item-content>
            </template>
            <template v-else>
              <v-list-item-content>
                <v-list-item-title v-html="data.item.name"></v-list-item-title>
              </v-list-item-content>
            </template>
          </template>
        </v-autocomplete>
      </v-col>
      </v-row>
        <v-autocomplete v-if="isItstaCode" :items="taxStatusCodes"
         class="input-text-size" label="Status Code"
         item-text="name"
         item-value="value"
         :value="staCodeValue"
         :readonly="isStatusCodeDisabled"
         :tabindex="isStatusCodeDisabled ? -1 : 0"
         @change="val => changed(val, 'statusCode')"
         :multiple = "selectMultiple"
         />
        <v-autocomplete v-if="isItAdditions" :items="additions"
         class="input-text-size" label="Addition"
         item-text="name"
         item-value="value"
         :value="taxAdditionValue"
         :readonly="isAdditionsDisabled"
         :tabindex="isAdditionsDisabled ? -1 : 0"
         :loading="isAdditionsLoading"
         :search-input.sync="searchAdditions"
         @change="val => changed(val, 'addition')">
          <template v-slot:append-item>
            <v-list-item v-intersect="onAdditionsIntersect">
              <v-list-item-content v-if="isAdditionsLoading">
                <v-list-item-title class="text-center">Loading more...</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-autocomplete>
        <v-autocomplete v-if="isItTaxDistrict" :items="taxDistrictFormatterFunc()"
         class="input-text-size" :label=taxDistrictLabelOverride
         item-text="name"
         item-value="value"
         :value="taxDistrictValue"
         :readonly="isTaxDistrictDisabled"
         :tabindex="isTaxDistrictDisabled ? -1 : 0"
         :title="taxDistrictTooltip"
         :rules="isItTaxDistrictRequired ? rulesForEmptyDropdown : []"
         @change="val => changed(val, taxDistrictNameOverride)" />
         <v-autocomplete v-if="isItTaxAdjTypes" :items="taxAdjTypesList"
         class="input-text-size" :label=AdjTypesLabelOverride
         item-text="name"
         item-value="value"
         :value="taxAdjTypesValue"
         :rules="taxAdjTypesRequired ? rulesForEmptyDropdown : []"
         @change="val => changed(val, adjTypesNameOverride)"/>
         <v-autocomplete v-if="isItTaxFee" :items="taxFeeList"
         class="input-text-size" :label="taxFeeLabelOverride"
         item-text="name"
         item-value="value"
         :value="taxFeeNumValue"
         :rules="taxFeeRequired ? rulesForEmptyDropdown : []"
         :readonly="isTaxFeesDisabled"
         :tabindex="isTaxFeesDisabled ? -1 : 0"
         @change="val => changed(val, taxFeeNameOverride)"/>
         <!-- Category and Tax Type already carried a separate :readonly prop alongside the
              :disabled one. Both now mean the same thing, so each pair collapses into a single
              binding rather than leaving callers to guess which of the two greys the value out.
              The two prop names are kept so existing callers keep working either way. -->
         <v-autocomplete v-if="isItCategory" :items="commentsCategory"
         class="input-text-size" label="Category"
         item-text="name"
         item-value="value"
         :readonly="isCommentsCategoryDisabled || isCommentsCategoryReadonly"
         :tabindex="isCommentsCategoryDisabled || isCommentsCategoryReadonly ? -1 : 0"
         :value="commentsCategoryValue"
         :rules="commentsCategoryRequired ? rulesForEmptyDropdown : []"
         :multiple="commentsCategoryMultiple"
         @change="val => changed(val, 'category')"/>
         <v-autocomplete v-if="isItTaxType" :items="taxTypeDropDownFunc"
         class="input-text-size" label="Tax Type"
         item-text="name"
         item-value="value"
         :readonly="isTaxTypeDisabled || isTaxTypeReadonly"
         :tabindex="isTaxTypeDisabled || isTaxTypeReadonly ? -1 : 0"
         :value="taxTypeValue"
         :rules="taxTypeRequired ? rulesForEmptyDropdown : []"
         @change="val => changed(val, 'taxType')"/>
    </div>
</template>

<script>
import {
  mapActions,
  mapGetters,
  mapState,
} from 'vuex';
import '../../../assets/style.css';
import { toFiscalYear } from '../../../util/shared/tmc-global';
import { mergeCodeWithName } from './CommonTaxFunctionalities';
import { SEARCH_DEBOUNCE_TIMER } from './constants';

export default {
  data() {
    return {
      isLoading: false,
      vModelList: {},
      searchMtgCodes: '',
      searchMtgCodesMulti: '',
      searchAdditions: '',
      isAdditionsLoading: false,
      latestFiscalYear: null,
      delayTimerId: null,
      intersecting: 0,
      combineMtgCodes: [],
    };
  },
  created() {
    this.latestFiscalYear = toFiscalYear(new Date(this.todaysDate));
  },
  computed: {
    ...mapState({
      taxYearList: (state) => state.tax.taxCommon.taxYearList,
      fiscalYearList: (state) => state.tax.taxCommon.fiscalYearList,
      taxMortgageCodes: (state) => state.shared.taxMortgageCodesShared.taxMortgageCodes,
      taxStatusCodes: (state) => state.shared.taxStatusCodesShared.taxStatusCodes,
      additions: (state) => state.shared.TaxAdditions.additions,
      hasMoreAdditions: (state) => state.shared.TaxAdditions.hasMore,
      latestTaxYear: (state) => state.tax.taxCommon.latestTaxYear,
      // latestFiscalYear: (state) => state.tax.taxCommon.latestFiscalYear,
      taxDistrict: (state) => state.base.crud.items.sharedTaxDistrict,
      taxAdjTypesList: (state) => state.base.crud.items.taxAdjTypesList,
      taxFeeList: (state) => state.base.crud.items.sharedTaxFeeMaster,
      commentsCategory: (state) => state.base.crud.items.sharedTaxComments,
      TaxTypeEnum: (state) => state.enums.TaxTypeEnum,
      taxSettingItem: (state) => state.SystemConfig.taxSettingItem || {},
    }),
    ...mapGetters(['todaysDate']),
    defaultTaxYearFromTaxSetting() {
      return Number((this.taxSettingItem || {}).taxYear) || 0;
    },
    rulesForEmptyDropdown() {
      return [
        (v) => !!v || 'Required.',
        () => true,
      ];
    },
    taxTypeDropDownFunc() {
      const updatedItems = mergeCodeWithName((this.TaxTypeEnum || []), 'name', 'description', true);
      return updatedItems;
    },
    computedTaxYearValue() {
      const { taxYearValue, latestTaxYear, defaultTaxYearFromTaxSetting } = this;
      const criteriaTaxYearVal = this.criteriaState && this.criteriaState.taxYear !== undefined
        ? this.criteriaState.taxYear : null;
      let val = null;
      if (taxYearValue === 0 || taxYearValue) val = taxYearValue;
      else if (criteriaTaxYearVal === 0 || criteriaTaxYearVal) val = criteriaTaxYearVal;
      else val = defaultTaxYearFromTaxSetting || latestTaxYear;
      return val;
    },
  },
  props: {
    isItMtgCode: {
      type: Boolean,
      default: false,
    },
    isItMtgCodeMutiSelect: {
      type: Boolean,
      default: false,
    },
    isItTaxYear: {
      type: Boolean,
      default: false,
    },
    isItFiscalYear: {
      type: Boolean,
      default: false,
    },
    isTaxYearWithoutAllDisabled: {
      type: Boolean,
      default: false,
    },
    isTaxYearWithNewYearDisabled: {
      type: Boolean,
      default: false,
    },
    isTaxYearDisabled: {
      type: Boolean,
      default: false,
    },
    isStatusCodeDisabled: {
      type: Boolean,
      default: false,
    },
    isTaxDistrictDisabled: {
      type: Boolean,
      default: false,
    },
    isMtgCodeDisabled: {
      type: Boolean,
      default: false,
    },
    isCommentsCategoryDisabled: {
      type: Boolean,
      default: false,
    },
    isTaxTypeDisabled: {
      type: Boolean,
      default: false,
    },
    isCommentsCategoryReadonly: {
      type: Boolean,
      default: false,
    },
    isTaxTypeReadonly: {
      type: Boolean,
      default: false,
    },
    isFiscalYearDisabled: {
      type: Boolean,
      default: false,
    },
    isTaxFeesDisabled: {
      type: Boolean,
      default: false,
    },
    isItTaxYearWithoutAllYears: {
      type: Boolean,
      default: false,
    },
    isItTaxYearWithNewYear: {
      type: Boolean,
      default: false,
    },
    addTaxYearEmpty: {
      type: Boolean,
      default: false,
    },
    isItstaCode: {
      type: Boolean,
      default: false,
    },
    isItAdditions: {
      type: Boolean,
      default: false,
    },
    isAdditionsDisabled: {
      type: Boolean,
      default: false,
    },
    isItTaxDistrict: {
      type: Boolean,
      default: false,
    },
    isItTaxDistrictRequired: {
      type: Boolean,
      default: false,
    },
    taxAdjTypesRequired: {
      type: Boolean,
      default: false,
    },
    taxFeeRequired: {
      type: Boolean,
      default: false,
    },
    commentsCategoryRequired: {
      type: Boolean,
      default: false,
    },
    taxTypeRequired: {
      type: Boolean,
      default: false,
    },
    isItTaxAdjTypes: {
      type: Boolean,
      default: false,
    },
    isItTaxFee: {
      type: Boolean,
      default: false,
    },
    taxFeeLabelOverride: {
      type: String,
      default: 'Fee #',
    },
    taxYearLabelOverride: {
      type: String,
      default: 'Tax Year',
    },
    taxYearLabelWithNewYearOverride: {
      type: String,
      default: 'Tax Year',
    },
    taxDistrictLabelOverride: {
      type: String,
      default: 'Tax District',
    },
    AdjTypesLabelOverride: {
      type: String,
      default: 'Adj Types',
    },
    taxFeeNameOverride: {
      type: String,
      default: 'feeNumber',
    },
    taxYearNameOverride: {
      type: String,
      default: 'taxYear',
    },
    taxYearNameWithNewYearOverride: {
      type: String,
      default: 'taxYear',
    },
    taxDistrictNameOverride: {
      type: String,
      default: 'taxDistrict',
    },
    adjTypesNameOverride: {
      type: String,
      default: 'taxAdjTypesList',
    },
    isItCategory: {
      type: Boolean,
      default: false,
    },
    isItTaxType: {
      type: Boolean,
      default: false,
    },
    taxYearValue: {
      type: Number,
      default: null,
    },
    fiscalYearValue: {
      type: Number,
      default: null,
    },
    mtgCodeValue: {
      type: String,
      default: '',
    },
    taxDistrictValue: {
      type: String,
      default: '',
    },
    taxDistrictTooltip: {
      type: String,
      default: '',
    },
    taxAdditionValue: {
      type: String,
      default: null,
    },
    staCodeValue: {
      type: [Number, Array],
      default: null,
      validator(value) {
        if (typeof value === 'number') {
          return true;
        }
        if (Array.isArray(value)) {
          return true;
          // return value.every((item) => typeof item === 'number');
        }

        return false;
      },
    },
    taxAdjTypesValue: {
      type: String,
      default: '',
    },
    taxFeeNumValue: {
      type: Number,
      default: null,
    },
    commentsCategoryValue: {
      type: [Number, Array],
      default: null,
    },
    commentsCategoryMultiple: {
      type: Boolean,
      default: false,
    },
    taxTypeValue: {
      type: String,
      default: null,
    },
    taxDistrictFilterFieldsName: {
      type: String,
      default: null,
    },
    criteriaState: {
      type: Object,
      default: () => {},
    },
    selectMultiple: {
      type: Boolean,
      default: false,
    },
    isFiscalYearWithoutAllYears: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    searchMtgCodesMulti(searchName) {
      this.apiCallOnEnterText(searchName, 'mtgCodeMulti');
    },
    searchMtgCodes(searchName) {
      this.apiCallOnEnterText(searchName, 'mtgCode');
    },
    searchAdditions(searchName) {
      if (searchName === null) return;
      // Vuetify 2 syncs search-input to the selected item's display text on mount/value-resolve.
      // Skip the API call in that case — it's not a real user search and would overwrite the
      // shared Vuex additions state (used by both criteria and dialog dropdowns).
      const selectedItem = this.additions.find((a) => a.value === this.taxAdditionValue);
      if (selectedItem && selectedItem.name === searchName) return;
      this.onAdditionsSearch(searchName);
    },
    mtgCodeValue: {
      immediate: true,
      deep: true,
      handler(newValue) {
        if (newValue) {
          this.apiCallOnEnterText(newValue, 'mtgCode', 'fromEdit');
          this.vModelList.mtgCode = newValue;
        } else this.vModelList.mtgCode = null;
      },
    },
    taxAdditionValue: {
      immediate: true,
      handler(newValue) {
        if (newValue && !this.additions.find((a) => a.value === newValue)) {
          this.onAdditionsSearch(newValue);
        }
      },
    },
  },
  methods: {
    ...mapActions('tax/taxCommon', [
      'loadTaxYearList',
      'loadFiscalYearList',
    ]),
    ...mapActions('shared/TaxAdditions', [
      'loadTaxAdditionsRecords',
      'loadMoreTaxAdditions',
    ]),
    ...mapActions('shared/taxStatusCodesShared', [
      'loadTaxStatusCodesSharedRecords',
    ]),
    ...mapActions('shared/taxMortgageCodesShared', [
      'loadTaxMortgageCodesSharedRecords',
    ]),
    ...mapActions('shared/taxDistrict', [
      'loadTaxDistrict',
    ]),
    ...mapActions('shared/taxAdjTypesShared', [
      'loadtaxAdjTypesSharedRecords',
    ]),
    ...mapActions('shared/taxFeeMaster', [
      'loadTaxFeeMasterTypes',
    ]),
    ...mapActions('shared/commentTypes', [
      'loadCommentTypes',
    ]),
    changed(newValue, whichField) {
      // Vuetify 2 autocomplete emits @change with raw typed text when the
      // dropdown has no matching items and the field is blurred. Reject any
      // addition value that is not an actual list item so a stray search
      // string never reaches the backend addition filter.
      if (whichField === 'addition') {
        const isValid = newValue == null
          || this.additions.some((a) => a.value === newValue);
        if (!isValid) return;
      }
      this.$emit('change', newValue, whichField);
    },
    removeAllYearsFromTaxYearList() {
      const emptyVal = { name: '', value: null };
      let taxYearArr = [...this.taxYearList];
      if (this.addTaxYearEmpty) taxYearArr = [emptyVal, ...taxYearArr];
      if (taxYearArr && taxYearArr.length > 0) {
        return taxYearArr.filter((ft) => ft.name !== 'all years');
      }
      return [];
    },
    removeAllYearsFromTaxYearListWithNewYear() {
      // this function is used to remove all years and new tax year to the list
      const taxYearArr = [...this.taxYearList];
      if (taxYearArr && taxYearArr.length > 0) {
        const newTaxYearArr = taxYearArr.filter((ft) => ft.name !== 'all years');
        let maxTaxYear = 0;
        // if latestTaxYear is not null, then use it as maxTaxYear
        if (this.latestTaxYear) maxTaxYear = this.latestTaxYear;
        else maxTaxYear = Math.max(...newTaxYearArr.map((ft) => ft.value));
        // add new tax year to the list
        const concatTaxYearWithNewTaxYear = [{ name: maxTaxYear + 1, value: maxTaxYear + 1 },
          ...newTaxYearArr];
        return concatTaxYearWithNewTaxYear;
      }
      return [];
    },
    taxDistrictFormatterFunc() {
      // filters-out the unwanted things
      let formattedArr = [];
      if (this.taxDistrictFilterFieldsName) {
        const filArr = (this.taxDistrict || [])
          .filter((ft) => !!ft[this.taxDistrictFilterFieldsName]);
        formattedArr = this.postProccessTaxDistrictData(filArr);
      } else formattedArr = this.postProccessTaxDistrictData(this.taxDistrict);
      return formattedArr;
    },
    removeEmptyFromMtgCodesList() {
      if (this.taxMortgageCodes && this.taxMortgageCodes.length > 0) {
        const filtered = this.taxMortgageCodes.filter((ft) => ft.name !== '');
        return filtered.sort((a, b) => {
          const aNamePart = a.name.includes(' - ') ? a.name.split(' - ')[1] : a.name;
          const bNamePart = b.name.includes(' - ') ? b.name.split(' - ')[1] : b.name;
          return aNamePart.localeCompare(bNamePart);
        });
      }
      return [];
    },
    isMtgCodeMultiIsEmptyOrNotFunc() {
      const returnVal = this.vModelList && this.vModelList.mtgCodeMulti
       && this.vModelList.mtgCodeMulti.length > 0
        ? this.vModelList.mtgCodeMulti : [];
      return returnVal;
    },
    remove(item) {
      const isMtgCodeMultiIsEmptyOrNot = this.isMtgCodeMultiIsEmptyOrNotFunc();
      this.vModelList.mtgCodeMulti = isMtgCodeMultiIsEmptyOrNot.filter((ft) => ft !== item);
      this.onMultiMtgCodechange();
    },
    onMultiMtgCodechange() {
      const isMtgCodeMultiIsEmptyOrNot = this.isMtgCodeMultiIsEmptyOrNotFunc();
      this.changed(isMtgCodeMultiIsEmptyOrNot, 'mtgCodeMulti');
    },
    async apiCallOnEnterText(searchName, whichDropDown, fromWhere) {
      const checkSearchNameIsEmptyOrNot = searchName !== null ? searchName : '';
      const checkMtgCodeEmptyOrNot = this.vModelList && this.vModelList[whichDropDown]
        ? this.vModelList[whichDropDown] : null;
      const conditionOne = checkSearchNameIsEmptyOrNot === '' && checkMtgCodeEmptyOrNot === '';
      const conditionTwo = !(checkSearchNameIsEmptyOrNot).includes(checkMtgCodeEmptyOrNot);
      if (fromWhere === 'fromEdit' && !!checkSearchNameIsEmptyOrNot) this.vModelList.mtgCode = checkSearchNameIsEmptyOrNot;
      if (conditionOne || conditionTwo) {
        this.isLoading = true;
        // Reset pagination counter for new search
        this.intersecting = 0;
        clearTimeout(this.delayTimerId);
        this.delayTimerId = setTimeout(async () => {
          const criteria = {
            limit: 100,
            skip: 0,
            searchByEnteredtext: (checkSearchNameIsEmptyOrNot || checkMtgCodeEmptyOrNot),
            sortBy: [{
              column: 'mtgCode',
              direction: 'asc',
            }],
          };
          await this.loadTaxMortgageCodesSharedRecords(
            { criteria, postProcessTrans: this.postProccessMTGData, isItSetState: true },
          ).then((val) => {
            this.combineMtgCodes = this.postProccessMTGData((val));
            this.isLoading = false;
          });
        }, SEARCH_DEBOUNCE_TIMER);
      }
    },
    postProccessTaxYearData(items) {
      const updatedItems = [{ name: 'all years', value: 0 }];
      for (let i = 0; i < items.length; i += 1) {
        updatedItems.push({ name: items[i], value: items[i] });
      }
      return updatedItems;
    },
    postProccessMTGData(items) {
      const updatedItems = mergeCodeWithName(items, 'mtgCode', 'mtgCoName', true);
      return updatedItems.sort((a, b) => {
        if (a.name === '') return -1;
        if (b.name === '') return 1;
        const aNamePart = a.name.includes(' - ') ? a.name.split(' - ')[1] : a.name;
        const bNamePart = b.name.includes(' - ') ? b.name.split(' - ')[1] : b.name;
        return aNamePart.localeCompare(bNamePart);
      });
    },
    postProccessStatusCodesData(items) {
      const updatedItems = mergeCodeWithName(items, 'statusCode', 'description', true);
      return updatedItems;
    },
    postProccessAdditionsData(items) {
      const updatedItems = mergeCodeWithName(items, 'additionCode', 'description', true);
      return updatedItems;
    },
    postProccessTaxDistrictData(items) {
      const updatedItems = mergeCodeWithName(items, 'districtCode', 'districtName', true);
      return updatedItems;
    },
    postProccessAdjTypesData(items) {
      const updatedItems = mergeCodeWithName(items, 'adjType', 'description', true);
      return updatedItems;
    },
    postProccessTaxFeeData(items) {
      const updatedItems = mergeCodeWithName(items, 'feeNumber', 'feeDescription', true);
      return updatedItems;
    },
    postProccessCommentsCategoryData(items) {
      const updatedItems = mergeCodeWithName(items, 'commentCode', 'description', true);
      return updatedItems;
    },
    handleDynamicTaxValChange() {
      if (this.taxYearValue === null) return this.taxYearValue;
      return this.taxYearValue || this.defaultTaxYearFromTaxSetting || this.latestTaxYear;
    },
    handleDynamicFiscalValChange() {
      return this.fiscalYearValue || this.latestFiscalYear;
    },
    handleFiscalYearWithoutAllYears() {
      if (this.isFiscalYearWithoutAllYears && this.fiscalYearList.length > 0) {
        return this.fiscalYearList.filter((ft) => ft.name !== 'all years');
      }
      return this.fiscalYearList;
    },
    onAdditionsSearch(searchName) {
      clearTimeout(this._additionsTimer);
      this._additionsTimer = setTimeout(async () => {
        this.isAdditionsLoading = true;
        const criteria = {
          limit: 50,
          skip: 0,
          sortBy: [{ column: 'additionCode', direction: 'asc' }],
        };
        if (searchName) criteria.additionCodeSearch = searchName;
        await this.loadTaxAdditionsRecords({
          criteria,
          postProcessTrans: this.postProccessAdditionsData,
          isItSetState: true,
        });
        this.isAdditionsLoading = false;
      }, SEARCH_DEBOUNCE_TIMER);
    },
    async onAdditionsIntersect(entries, observer, isIntersecting) {
      if (isIntersecting && !this.isAdditionsLoading && this.hasMoreAdditions) {
        this.isAdditionsLoading = true;
        await this.loadMoreTaxAdditions({ postProcessTrans: this.postProccessAdditionsData });
        this.isAdditionsLoading = false;
      }
    },
    async onAutocompleteIntersect(entries, observer, isIntersecting) {
      if (isIntersecting && !this.isLoading) {
        this.isLoading = true;

        // Proper pagination: skip the records we've already loaded
        const limit = 100;
        const skip = this.intersecting * limit;

        const criteria = {
          limit,
          skip,
          searchByEnteredtext: this.searchMtgCodes || '',
          sortBy: [{
            column: 'mtgCode',
            direction: 'asc',
          }],
        };

        try {
          // Get current data before making API call
          const currentData = [...this.taxMortgageCodes];

          // Load new data
          const newData = await this.loadTaxMortgageCodesSharedRecords(
            { criteria, postProcessTrans: this.postProccessMTGData, isItSetState: false },
          );

          // Manually append new data to existing data
          if (newData && newData.length > 0) {
            const processedNewData = this.postProccessMTGData(newData);
            this.combineMtgCodes = [...currentData, ...processedNewData];

            // Update store with combined data
            this.$store.commit('shared/taxMortgageCodesShared/setTaxMortgageCodes', this.combineMtgCodes);
            this.intersecting += 1;
          }
        } catch (error) {
          console.error('Error loading more mortgage codes:', error);
        } finally {
          this.isLoading = false;
        }
      }
    },
  },
};
</script>
